module.exports = __webpack_public_path__ + "static/img/about1.3a1bd1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/content/about1.jpg
// module id = BUei
// module chunks = 3